import React from 'react';
import { ModelFactory } from '@leverege/ui-plugin';
import { List, Text, Flex, Checkbox } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.screens.group.FieldListRenderer');
export default function FieldListRenderer(props) {
  const {
    item,
    onChangeFieldActive,
    ...rest
  } = props;
  let name;
  const model = ModelFactory.get(item.type);
  if (model) {
    name = model?.getName(item);
  }
  if (name == null) {
    name = item.displayName || item.name || item.attrName || item.type || t('unknown');
  }
  return /*#__PURE__*/_jsx(List.Item, {
    item: item,
    ...rest,
    children: /*#__PURE__*/_jsxs(Flex, {
      variant: "rowM",
      align: "center",
      children: [/*#__PURE__*/_jsx(Checkbox, {
        value: item.active,
        eventData: item,
        onChange: onChangeFieldActive
      }), /*#__PURE__*/_jsx(Text, {
        variant: "listItemSubtitle",
        children: name
      })]
    })
  });
}